// eslint-disable-next-line no-shadow
enum MessageType {
  TEXT,
  FILE,
}

export default MessageType;
